import { createSlice } from '@reduxjs/toolkit'
import { langDefault } from '../utils/language'

export const langSlice = createSlice({
  name: 'lang',
  initialState: {
    value: langDefault,
  },
  reducers: {
    changeLang: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { changeLang } = langSlice.actions

export const getLang = (state) => {
  return state.lang.value
}

export default langSlice.reducer
